export const DEFAULT_TENANT_THEME = {
  version: '1.0.0',
  tenantId: 'default',
  branding: {
    name: 'FlowSure',
    logoUrl: '/tenant-assets/logo_blanco.svg',
    faviconUrl: ''
  },
  tokens: {
    color: {
      primary: '#2A2AC0',
      secondary: '#261D56',
      surface: '#F9FCFF',
      text: '#261D56',
      success: '#28A745',
      error: '#EF4444'
    },
    radius: {
      sm: 8,
      md: 12,
      lg: 20
    },
    spacing: {
      xs: 4,
      sm: 8,
      md: 16,
      lg: 24
    },
    font: {
      heading: 'Poppins, sans-serif',
      body: 'Roboto, sans-serif'
    }
  }
};
